import { isTrueFlag } from './value-util'

// Boolean flags carried by the per-product OrderRequirements of the CC and CC+ responses.
const ORDER_REQUIREMENT_FLAGS = [
  'UoApiAfterCreditCheck',
  'AllowAltShipping',
  'PaymentAllowAch',
  'PaymentTodayAllowAch',
  'PaymentAutopayAllowAch',
  'PaymentZipMustMatchService'
] as const

/**
 * Reads an OrderRequirements flag as a boolean. CC sends booleans, but CC+ has sent the same
 * flags as "true"/"false" strings, and a non-empty "false" is truthy.
 */
export function toRequirementFlag(value: unknown): boolean {
  return isTrueFlag(value)
}

/** Returns a copy of one product's OrderRequirements with its known flags read as booleans. */
export function normalizeRequirementFlags<T>(requirements: T): T {
  if (!requirements || typeof requirements !== 'object') {
    return requirements
  }
  const normalized = { ...requirements } as Record<string, unknown>
  for (const flag of ORDER_REQUIREMENT_FLAGS) {
    if (flag in normalized) {
      normalized[flag] = toRequirementFlag(normalized[flag])
    }
  }
  return normalized as T
}
